'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Svg = require('./Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Instagram = function Instagram(_ref) {
  var width = _ref.width,
      link = _ref.link,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['width', 'link', 'title']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ title: title, width: width, href: link, onClick: link ? undefined : _Actions2.default['instagram']
    }, props),
    _react2.default.createElement(
      _Svg2.default,
      _extends({ width: width, height: width, viewBox: '0 0 37 37' }, props, { version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }),
      _react2.default.createElement(
        'title',
        null,
        title,
        ' button'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'transparent', fillRule: 'evenodd' },
        _react2.default.createElement('circle', { cx: '17.5', cy: '17.5', r: '17.5', transform: 'translate(.636 1)' }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(10 10)' },
          _react2.default.createElement('path', { d: 'M14.98 4.478a.74.74 0 0 1-.737.738h-1.81a.74.74 0 0 1-.737-.738V2.633a.74.74 0 0 1 .737-.738h1.81a.74.74 0 0 1 .737.738v1.845zm-.002 9.882c0 .504-.223.747-.726.747H2.842c-.54 0-.82-.155-.82-.747V7.132h1.473A5.191 5.191 0 0 0 8.5 13.694a5.191 5.191 0 0 0 5.005-6.562h1.473v7.228zM8.5 5.198A3.3 3.3 0 0 1 11.797 8.5 3.3 3.3 0 0 1 8.5 11.802 3.3 3.3 0 0 1 5.203 8.5 3.3 3.3 0 0 1 8.5 5.198zM14.956 0H2.044A2.052 2.052 0 0 0 0 2.047v12.906C0 16.079.92 17 2.044 17h12.912A2.052 2.052 0 0 0 17 14.953V2.047C17 .921 16.08 0 14.956 0z' })
        )
      )
    )
  );
};

Instagram.defaultProps = {
  title: "Share on Instagram"
};

exports.default = Instagram;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Instagram.js
// module id = 442
// module chunks = 168707334958949